import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { Play } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import VideoPreviewModal from '../VideoPreviewModal/VideoPreviewModal'

import { getUpsellData, UPSELL_TYPE_ALIASES } from './constants'
import RequestSentModal from './RequestSentModal'

const Upselling = ({ containerStyle, params }) => {
  const { t } = useTranslation(['upselling'])
  const [isVideoModalVisible, setIsVideoModalVisible] = useState(false)

  let { type } = useParams()

  if (params?.type) {
    type = params.type
  }

  type = UPSELL_TYPE_ALIASES[type] ?? type

  const upsellData = getUpsellData(t)[type]

  if (!upsellData) {
    return (
      <div className="ctp-upselling" style={containerStyle}>
        <div className="ctp-upselling__container">
          <div className="ctp-upselling__container__main-content">
            <h1 className="ctp-upselling__container__main-content__title">
              {t('upselling:page.fallbackTitle')}
            </h1>
            <p className="ctp-upselling__container__main-content__description">
              {t('upselling:page.fallbackDescription')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="ctp-upselling" style={containerStyle}>
      <div className="ctp-upselling__container">
        <div className="ctp-upselling__container__main-content">
          <div className="ctp-upselling__container__main-content__text-with-icon">
            <img
              className="img-icon"
              src="/images/arrow-up.svg"
              alt={t('upselling:page.arrowUpAlt')}
            />
            <p className="ctp-upselling__container__main-content__text-with-icon__pre-title-text">
              {upsellData.preTitleText}
            </p>
          </div>
          <h1 className="ctp-upselling__container__main-content__title">{upsellData.title}</h1>
          <p className="ctp-upselling__container__main-content__description">
            {upsellData.description}
          </p>
          {upsellData.textToRender()}
          <RequestSentModal buttonClassName="button-with-margin-top" type={type} />
        </div>
        <div
          className={`ctp-upselling__container__image-wrapper ${
            upsellData.videoUrl ? 'ctp-upselling__container__image-wrapper--clickable' : ''
          }`}
          onClick={upsellData.videoUrl ? () => setIsVideoModalVisible(true) : undefined}
        >
          <img className="ctp-upselling__container__image" src={upsellData.image} />
          {upsellData.videoUrl && (
            <div className="ctp-upselling__container__play-icon">
              <Play size={64} weight="fill" />
            </div>
          )}
        </div>
        {isVideoModalVisible && upsellData.videoUrl && (
          <VideoPreviewModal
            handleCloseVideo={() => setIsVideoModalVisible(false)}
            videoUrl={upsellData.videoUrl}
          />
        )}
      </div>
    </div>
  )
}

Upselling.propTypes = {
  containerStyle: PropTypes.object,
  params: PropTypes.object,
}

export default Upselling
